import { NoSymbolIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import tw, { styled } from 'twin.macro';
import { useAtom } from 'jotai';

import { ButtonV2, Title } from '@restworld/ui-ds';

import { selectedJobApplicationAtom } from '../../../employer-job-listing.atoms';

function CandidateStateUpdateSuccess({ onClose }: { onClose: () => void; isDiscarded?: boolean }) {
  const { t } = useTranslation('job-positions-page');
  const [selectedJobApplication] = useAtom(selectedJobApplicationAtom);
  const candidateName = selectedJobApplication?.worker?.name ?? '';

  return (
    <Wrapper>
      <NoSymbolIcon tw="h-6 w-6 text-red-700 inline-block mx-auto" />
      <Title fontWeight="semibold" fontSize="large" textColor="neutral-700" twStyle={tw`text-base lg:text-lg`}>
        {t('you_discarded_name', { name: candidateName })}
      </Title>
      <ContentWrapper>{t('we_will_send_candidate_email_explaining_reasons')}</ContentWrapper>
      <ButtonV2 onClick={() => onClose()}>{t('close')}</ButtonV2>
    </Wrapper>
  );
}
export default CandidateStateUpdateSuccess;

const Wrapper = styled.div`
  ${tw`h-full w-full max-w-[650px] mx-auto flex flex-col justify-center items-center gap-5 text-center`}
`;
const ContentWrapper = styled.p`
  ${tw`text-neutral-200 font-medium max-w-[620px]`}
`;
